import addHeader from './Api'
import { TEST } from '../../config/config'
import PAGRating from '../../Types'

const API_BASE = '/api/'

export interface filterReporting {
  from: number
  to: number
  app: Array<number>
  subApp: Array<number>
  module: Array<number>
  includeAppHierarchy: Boolean
  department: Array<number>
  includedepartmenthierarchy: Boolean
  responsible: string
}

export async function getAll() {
  return await fetch(API_BASE + 'applications-get?companyId=1', {
    method: 'GET',
    headers: addHeader()
  })
}

export async function create(appData: PAGRating.FormAppInformation) {
  const data = {
    icto: 'ICTO-' + appData.icto,
    appId: 'APP-' + appData.appId,
    appDescription: appData.appDescription,
    department: 'FD' + appData.department.toUpperCase(),
    members: [
      {
        name: appData.applicationManager,
        email: appData.applicationManagerEmail,
        role: 'am'
      }
    ],
    businessResponsible: appData.businessResponsible,
    test: TEST,
    active: true
  }
  appData.members?.map((value) => {
    if (value !== '') {
      data.members.push({
        name: '',
        email: '' + value,
        role: 'o'
      })
    }
    return value
  })
  return await fetch(API_BASE + 'application-post?companyId=1', {
    method: 'POST',
    headers: addHeader(),
    body: JSON.stringify(data)
  })
}

export async function update(appData: PAGRating.FormAppInformation) {
  const data = {
    icto: 'ICTO-' + appData.icto,
    appId: 'APP-' + appData.appId,
    appDescription: appData.appDescription,
    department: 'FD' + appData.department.toUpperCase(),
    members: [
      {
        name: appData.applicationManager,
        email: appData.applicationManagerEmail,
        role: 'am'
      }
    ],
    businessResponsible: appData.businessResponsible,
    test: TEST,
    active: true,
    companyId: '1',
    configId: appData.configId,
    app: appData.app,
    id: appData.id,
    subApp: appData.subApp
  }
  appData.members?.map((value) => {
    data.members.push({
      name: '',
      email: '' + value,
      role: 'o'
    })
  })
  return await fetch(API_BASE + 'application-put/' + appData.app + '?companyId=1', {
    method: 'PUT',
    headers: addHeader(),
    body: JSON.stringify(data)
  })
}

export async function archiveOne(appData: PAGRating.FormAppInformation) {
  const data = {
    icto: appData.icto,
    appId: appData.appId,
    appDescription: appData.appDescription,
    department: appData.department,
    businessResponsible: appData.businessResponsible,
    members: [
      {
        name: appData.applicationManager,
        email: appData.applicationManagerEmail,
        role: 'am'
      }
    ],
    test: TEST,
    active: false,
    companyId: '1',
    configId: appData.configId,
    app: appData.app
  }
  appData.members?.map((value) => {
    data.members.push({
      name: '',
      email: '' + value,
      role: 'o'
    })
  })
  return await fetch(API_BASE + 'application-put/' + appData.app + '?companyId=1', {
    method: 'PUT',
    headers: addHeader(),
    body: JSON.stringify(data)
  })
}

export async function generateApiKey(appId: number) {
  return await fetch(API_BASE + 'application-generate-apikey/' + appId + '?companyId=1', {
    method: 'POST',
    headers: addHeader()
  })
}

export async function getRatingsByConfigIds(configIds: string[], from: number, to: number) {
  return await fetch(API_BASE + 'reporting-ratings-by-configids-post?companyId=1', {
    method: 'POST',
    headers: addHeader(),
    body: JSON.stringify({
      filter: { configIds, from, to }
    })
  })
}

export async function deleteOne(id: number) {
  return await fetch(API_BASE + 'application-get/' + id + '?companyId=1', {
    method: 'DELETE',
    headers: addHeader()
  })
}

export async function checkIctoExistence(icto: string) {
  return await fetch(API_BASE + 'icto-exists/' + icto + '?companyId=1', {
    method: 'GET',
    headers: addHeader()
  })
}

export async function getReporting(
  filter: filterReporting,
  groupBy:
    | 'bydetails'
    | 'bydetailsexport'
    | 'byday'
    | 'byrating'
    | 'bydepartment'
    | 'byapplication'
    | 'byMainDepartment3'
    | 'average',
  orderBy: 'appName' | 'date' | 'rating' | 'comment' | 'sentiment' = 'appName',
  order: 'ASC' | 'DESC' = 'ASC',
  offset: number = 0,
  limit: number = 21
) {
  let data
  if (groupBy === 'bydetails') {
    data = {
      filter: filter,
      groupBy: groupBy,
      orderBy: orderBy,
      order: order,
      offset: offset,
      limit: limit
    }
  } else {
    data = {
      filter: filter,
      groupBy: groupBy
    }
  }

  return await fetch(API_BASE + 'reporting-applications-post/?companyId=1', {
    method: 'POST',
    headers: addHeader(),
    body: JSON.stringify(data)
  })
}

export async function getSentiment(filter: filterReporting) {
  const data = {
    filter: filter,
    groupBy: 'bydetails',
    orderBy: 'sentiment',
    order: 'DESC',
    offset: 0,
    limit: 1000
  }

  return await fetch(API_BASE + 'reporting-sentiment-post?companyId=1', {
    method: 'POST',
    headers: addHeader(),
    body: JSON.stringify(data)
  })
}

export async function getKeyPhrases(filter: filterReporting) {
  const data = {
    filter: filter,
    groupBy: 'bydetails',
    orderBy: 'sentiment',
    order: 'DESC',
    offset: 0,
    limit: 1000,
    minCount: 2
  }
  return await fetch(API_BASE + 'reporting-keyPhrases-post?companyId=1', {
    method: 'POST',
    headers: addHeader(),
    body: JSON.stringify(data)
  })
}

export async function getRatingCount(filter: filterReporting) {
  return await fetch(API_BASE + 'reporting-applications-count-post/?companyId=1', {
    method: 'POST',
    headers: addHeader(),
    body: JSON.stringify({
      filter: filter
    })
  })
}

export async function getDepartmentList() {
  return await fetch(API_BASE + 'reporting-departments-list-get/?companyId=1', {
    method: 'GET',
    headers: addHeader()
  })
}
